// Data (Local)
const actionGroupName = 'ACCOUNT'

// Constants (Local)
const ACCOUNT_ACTIONS = Object.freeze({
	ACCEPT_TERMS: `ACCEPT_${actionGroupName}_TERMS`,
	ADD_TEAM: `ADD_${actionGroupName}_TEAM`,
	SET: `SET_${actionGroupName}`,
	SET_TEAM: `SET_${actionGroupName}_TEAM`,
	SET_PHONE_NUMBER: `SET_${actionGroupName}_PHONE_NUMBER`
})

// Reducer: Account
function account (state, action) {
	// Actions
	switch (action.type) {
		// Action: Accept terms
		case ACCOUNT_ACTIONS.ACCEPT_TERMS:
			return {
				...state,
				account: {
					...state.account,
					isLatestTermsOfServiceAccepted: true
				}
			}
		// Action: Add team
		case ACCOUNT_ACTIONS.ADD_TEAM:
			return {
				...state,
				account: {
					...state.account,
					teams: [
						...state.account.teams,
						action.payload
					]
				}
			}
		// Action: Set
		case ACCOUNT_ACTIONS.SET:
			return {
				...state,
				account: {
					...(state.account || {}),
					...action.payload
				}
			}
		// Action: Set phone number
		case ACCOUNT_ACTIONS.SET_PHONE_NUMBER:
			return {
				...state,
				account: {
					...state.account,
					isPhoneNumberVerified: true,
					isPhoneNumberVerifiedBefore: true,
					phoneNumber: action.payload
				}
			}
		// Action: Set team
		case ACCOUNT_ACTIONS.SET_TEAM:
			return {
				...state,
				account: {
					...state.account,
					team: {
						...state.account.team,
						id: action.payload
					}
				}
			}
		// Fallback
		default:
			return state
	}
}

// Export
export default account
export {
	ACCOUNT_ACTIONS
}
